/**
 * Coerce a nullish value to an empty array, or return the value as is.
 * Additionally, filter nullish values from the array.
 *
 * @param val An unknown value
 * @return The value if it is not nullish, otherwise undefined
 */
export function nullishToEmptyArray(val) {
    if (val == null) {
        return [];
    }
    return val.filter(item => item != null);
}
//# sourceMappingURL=nullishToEmptyArray.js.map